(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["before-after"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('lusso-comparison-gallery')) {
  customElements.define('lusso-comparison-gallery', class extends HTMLElement {
    connectedCallback() {
      this.cleanup?.abort();
      this.cleanup = new AbortController();
      const options = { signal: this.cleanup.signal };
      this.slides = [...this.querySelectorAll('[data-comparison-block]')];
      this.index = 0;
      this.mobileQuery = window.matchMedia('(max-width: 899px)');
      this.mobileQuery.addEventListener('change', () => this.show(this.index), options);
      this.show(0);
      this.querySelectorAll('.comparison-range').forEach(input => {
        const frame = input.closest('.comparison-frame');
        const update = () => {
          const value = Math.max(0, Math.min(100, Number(input.value)));
          frame.style.setProperty('--comparison-split', `${value}%`);
          input.setAttribute('aria-valuetext', `${value}% ${input.dataset.beforeLabel}`);
        };
        const move = event => {
          const box = frame.getBoundingClientRect();
          if (!box.width) return;
          input.value = String(Math.round(Math.max(0, Math.min(100, (event.clientX-box.left)/box.width*100))));
          update();
        };
        input.addEventListener('input', update, options);
        input.addEventListener('pointerdown', event => {
          if (event.button !== 0) return;
          event.preventDefault(); input.focus({preventScroll:true});
          input.setPointerCapture(event.pointerId); move(event);
        }, options);
        input.addEventListener('pointermove', event => {
          if (input.hasPointerCapture(event.pointerId)) move(event);
        }, options);
        input.addEventListener('pointerup', event => {
          if (input.hasPointerCapture(event.pointerId)) input.releasePointerCapture(event.pointerId);
        }, options);
        update();
      });
      this.querySelector('[data-comparison-prev]')?.addEventListener('click', () => this.show(this.index-this.perView), options);
      this.querySelector('[data-comparison-next]')?.addEventListener('click', () => this.show(this.index+this.perView), options);
      this.querySelectorAll('.comparison-frame--combined').forEach(frame => {
        let start;
        frame.addEventListener('dragstart', event => event.preventDefault(), options);
        frame.addEventListener('pointerdown', event => {
          if (event.button !== 0) return;
          start = {x:event.clientX,y:event.clientY};
          frame.setPointerCapture(event.pointerId);
        }, options);
        frame.addEventListener('pointerup', event => {
          if (!start) return;
          const dx=event.clientX-start.x, dy=event.clientY-start.y;
          start=null;
          if (Math.abs(dx)>50 && Math.abs(dx)>Math.abs(dy)) this.show(this.index+(dx<0?this.perView:-this.perView));
        }, options);
        frame.addEventListener('pointercancel', () => { start=null; }, options);
      });
      document.addEventListener('shopify:block:select', event => {
        const index = this.slides.findIndex(slide => slide.dataset.comparisonBlock === event.detail.blockId);
        if (index >= 0) this.show(index);
      }, options);
    }
    show(index) {
      if (!this.slides.length) return;
      const configured = Number(this.mobileQuery.matches ? this.dataset.mobileColumns : this.dataset.columns);
      this.perView = Math.min(this.slides.length, Math.max(1, Math.min(3, Math.floor(configured || 1))));
      const pages = Math.ceil(this.slides.length / this.perView);
      const requestedPage = Math.floor(index / this.perView);
      const page = ((requestedPage % pages) + pages) % pages;
      this.index = page * this.perView;
      this.style.setProperty('--comparison-cols', String(this.perView));
      this.slides.forEach((slide,i) => { slide.hidden = i < this.index || i >= this.index + this.perView; });
      const counter = this.querySelector('[data-comparison-count]');
      const last = Math.min(this.index + this.perView, this.slides.length);
      if (counter) counter.textContent = `${this.index+1}${last > this.index+1 ? '–'+last : ''} / ${this.slides.length}`;
      const navigation = this.querySelector('.comparison-navigation');
      if (navigation) navigation.hidden = pages <= 1;
    }
    disconnectedCallback() { this.cleanup?.abort(); }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["course-signup"] && !Shopify.designMode) return;
  try {
    
function initCourse(root) {
  root.querySelectorAll('[data-course-section]').forEach(section => {
    if (section.dataset.ready) return;
    section.dataset.ready = 'true';
    const form = section.querySelector('.course-signup');
    const date = section.querySelector('[data-course-date]');
    if (date) {
      const validateDate = () => {
        const chosen = date.value ? new Date(date.value + 'T12:00:00') : null;
        date.setCustomValidity(chosen && chosen.getDay() !== 1 ? section.dataset.mondayError : '');
      };
      date.addEventListener('input', validateDate);
      form.addEventListener('submit', event => {
        validateDate();
        if (!form.reportValidity()) {event.preventDefault();return;}
        try {
          sessionStorage.setItem('lussoCourseSignup', JSON.stringify({
            at: Date.now(),
            name: form.elements['contact[name]'].value,
            email: form.elements['contact[email]'].value,
            phone: form.elements['contact[phone]'].value,
            monday: date.value
          }));
        } catch (error) {}
      });
    }
    const success = section.querySelector('[data-course-success]');
    if (success) {
      success.focus();
      const checkout = section.querySelector('[data-course-checkout]');
      try {
        const signup = JSON.parse(sessionStorage.getItem('lussoCourseSignup') || 'null');
        if (checkout && signup && Date.now() - signup.at < 3600000) {
          const url = new URL(checkout.href);
          url.searchParams.set('checkout[email]', signup.email);
          url.searchParams.set('attributes[Course attendee]', signup.name);
          url.searchParams.set('attributes[Attendee phone]', signup.phone);
          if (signup.monday) url.searchParams.set('attributes[Preferred Monday]', signup.monday);
          checkout.href = url.href;
        }
        sessionStorage.removeItem('lussoCourseSignup');
      } catch (error) {}
    }
  });
}
initCourse(document);
document.addEventListener('shopify:section:load', event => initCourse(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["editable-newsletter-popup"]) return;
  try {
    
  (() => {
    const root = document.querySelector('[data-newsletter-popup]');
    if (!root || root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';
    const dialog = root.querySelector('[data-popup-dialog]');
    if (!dialog || !dialog.showModal) return;
    const storageKey = `lusso-newsletter-popup:${root.dataset.popupId}`;
    const frequency = Number(root.dataset.frequencyDays || 7) * 86400000;
    const designMode = root.dataset.showInEditor === 'true';
    const mobile = matchMedia('(max-width: 749px)').matches;
    const delay = Number(mobile ? root.dataset.delayMobile : root.dataset.delayDesktop) || 0;
    let dismissedAt = 0;
    try { dismissedAt = Number(localStorage.getItem(storageKey) || 0); } catch {}
    const canOpen = designMode || Date.now() - dismissedAt >= frequency;
    const open = () => {
      if (!dialog.open) dialog.showModal();
    };
    if (root.querySelector('[data-popup-success]')) {
      open();
      try { localStorage.setItem(storageKey, String(Date.now())); } catch {}
    } else if (canOpen) {
      window.setTimeout(open, designMode ? 150 : delay);
    }
    const close = () => {
      if (dialog.open) dialog.close();
      if (!designMode) {
        try { localStorage.setItem(storageKey, String(Date.now())); } catch {}
      }
    };
    root.querySelectorAll('[data-popup-close]').forEach(button => button.addEventListener('click', close));
    dialog.addEventListener('click', event => {
      const rect = dialog.getBoundingClientRect();
      if (event.target === dialog && (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom)) close();
    });
    dialog.addEventListener('cancel', event => { event.preventDefault(); close(); });
    document.addEventListener('shopify:section:select', event => {
      if (event.detail.sectionId === root.dataset.popupId) open();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["photo-gallery"] && !Shopify.designMode) return;
  try {
    
function initPhotoGallery(root) {
  root.querySelectorAll('[data-photo-gallery]').forEach(gallery => {
    if (gallery.dataset.initialized) return;
    gallery.dataset.initialized = 'true';
    const dialog = gallery.querySelector('[data-gallery-dialog]');
    const fullImage = dialog.querySelector('[data-gallery-full]');
    const caption = dialog.querySelector('[data-gallery-caption]');
    let opener;
    gallery.addEventListener('click', event => {
      const button = event.target.closest('[data-gallery-open]');
      if (!button) return;
      if (typeof dialog.showModal !== 'function') {window.open(button.dataset.image, '_blank', 'noopener');return;}
      opener = button;
      fullImage.src = button.dataset.image;
      fullImage.alt = button.dataset.alt;
      caption.textContent = button.dataset.caption;
      caption.hidden = !button.dataset.caption;
      dialog.showModal();
    });
    dialog.addEventListener('click', event => {
      if (event.target !== dialog) return;
      const bounds = dialog.getBoundingClientRect();
      if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
    });
    dialog.addEventListener('close', () => {fullImage.removeAttribute('src');opener?.focus();});
  });
}
initPhotoGallery(document);
document.addEventListener('shopify:section:load', event => initPhotoGallery(event.target));

  } catch(e) { console.error(e); }
})();
})();
